import { render, staticRenderFns } from "./AlertNotification.vue?vue&type=template&id=f9cf790a&scoped=true&"
import script from "./AlertNotification.vue?vue&type=script&lang=ts&"
export * from "./AlertNotification.vue?vue&type=script&lang=ts&"
import style0 from "./AlertNotification.vue?vue&type=style&index=0&id=f9cf790a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cf790a",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn});
